<template>
  <div class="exception">
    <div class="content">
      <h1>{{ config[type].title }}</h1>
      <div class="desc">{{ config[type].desc }}</div>
      <div class="action">
        <a-button type="primary" @click="handleToHome">{{ config[type].btnName }}</a-button>
      </div>
    </div>
    <div class="img">
      <img v-if="type == 403" src="../../assets/403.svg" />
      <img v-if="type == 404" src="../../assets/404.svg" />
      <img v-if="type == 500" src="../../assets/500.svg" />
    </div>
  </div>
</template>

<script>
import types from './type'

export default {
  name: 'ExceptionPage',
  props: {
    type: {
      type: String,
      default: '404',
    },
  },
  data() {
    return {
      config: types,
    }
  },
  methods: {
    handleToHome() {
      if (this.type == 403) {
        this.$router.push({ path: 'user' })
      } else {
        this.$router.push({ path: '/dashboard/analysis' })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.exception {
  align-items: center;
  text-align: center;
  padding-top: calc(50vh - 296px);
  background: white;
  padding-bottom: calc(50vh - 296px);

  .img {
    display: inline-block;
    // padding-right: 52px;
    zoom: 1;
    img {
      height: 360px;
      max-width: 430px;
    }
  }
  .content {
    // display: inline-block;
    flex: auto;
    margin-bottom: 50px;

    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
}

.mobile {
  .exception {
    .img {
      padding-right: unset;

      img {
        height: 40%;
        max-width: 80%;
      }
    }
  }
}
</style>